module.exports = __webpack_public_path__ + "img/3-3.c445d03a.svg";